import { useMemo } from 'react';
import { sessionActions, useSession } from '../../application/stores/sessionStore';
import { useContainer } from '../../di/ContainerProvider';

export function useAuth() {
  const { authApi } = useContainer();
  const user = useSession((s) => s.user);
  const status = useSession((s) => s.status);
  const actions = useMemo(() => sessionActions(authApi), [authApi]);
  return { user, status, ...actions };
}
